import { map } from 'rxjs';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CartFurnisherComponent } from '@b2b/components/cart/cart-furnisher/cart-furnisher.component';
import { TranslateModule } from '@ngx-translate/core';
import { CartService } from '@b2b/features/cart/core/cart.service';

@Component({
  selector: 'checkout-review',
  imports: [CommonModule, TranslateModule, CartFurnisherComponent],
  templateUrl: './checkout-review.component.html',
  styleUrl: './checkout-review.component.scss',
})
export class CheckoutReviewComponent {
  cart$ = this.cartService.getCart();

  templateContext$ = this.cart$.pipe(
    map(cart => ({
      isEmpty: (cart.data?.entries?.length ?? 0) === 0,
    })),
  );

  constructor(private cartService: CartService) {}
}
